import React, { useState } from 'react';
import { CopyIcon, CheckIcon, ShareIcon } from 'lucide-react';
export function ReferralCard() {
  const [copied, setCopied] = useState(false);
  const invitationCode = 'NIU5303';
  const handleCopy = () => {
    navigator.clipboard.writeText(invitationCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="bg-gradient-to-r from-purple-600 to-[#1E2B55] rounded-xl p-4 text-white" data-id="element-1021" data-mp="1q5gk0mfr06rv">
      <div className="flex items-start justify-between mb-3" data-id="element-1022" data-mp="1celhdrvuelwq">
        <div className="flex-1" data-id="element-1023" data-mp="1h6v5d2dedbwd">
          <h3 className="text-base font-bold mb-1" data-id="element-1024" data-mp="1h7xt51ffay82">
            Give your friends 15 SAR & Get 30 SAR
          </h3>
        </div>
        <button className="p-2 bg-white bg-opacity-20 rounded-lg hover:bg-opacity-30 transition-colors" data-id="element-1025" data-mp="17gte61pqzdd8">
          <ShareIcon className="w-5 h-5" data-id="element-1026" data-mp="thaii8e4huht" />
        </button>
      </div>
      <div className="flex items-center gap-2 bg-white bg-opacity-20 rounded-lg p-3" data-id="element-1027" data-mp="tj53tntb3omf">
        <div className="flex-1" data-id="element-1028" data-mp="xhueh8myms2d">
          <p className="text-xs text-purple-100 mb-1" data-id="element-1029" data-mp="3g57rvr1y067t">Invitation code:</p>
          <p className="text-sm font-bold" data-id="element-1030" data-mp="3g7asf50q1hqs">{invitationCode}</p>
        </div>
        <button onClick={handleCopy} className="px-3 py-1.5 bg-white text-purple-600 text-xs font-semibold rounded-md hover:bg-gray-100 transition-colors flex items-center gap-1" data-id="element-1031" data-mp="3b5br00ojkuwh">
          {copied ? <>
              <CheckIcon className="w-3 h-3" data-id="element-1032" data-mp="2xegnl3wtb60a" />
              Copied
            </> : 'Copy'}
        </button>
      </div>
    </div>;
}